export const useLowerCase = (val) => {
  return _lowerCase(val);
}